import React from "react";

import { useTranslation } from "@refinedev/core";

import { Paper, Stack, Typography } from "@mui/material";

/**
 * PLACEHOLDER COMPONENT - For development use only.
 * This component should be replaced with actual functionality
 * when the feature is implemented. Do not use for permanent UI.
 */

interface ComingSoonPlaceholderProps {
  message: string;
}

export const ComingSoonPlaceholder: React.FC<ComingSoonPlaceholderProps> = ({ message }) => {
  const { translate } = useTranslation();

  return (
    <Paper variant="outlined">
      <Stack p={4} alignItems="center">
        <Typography variant="h6" color="text.secondary" mb={1}>
          {translate("common.comingSoon")}
        </Typography>
        <Typography variant="body2" color="text.disabled">
          {message}
        </Typography>
      </Stack>
    </Paper>
  );
};
